/**
 * Base origin for the public saddle-fit website (event booking links).
 * - Optional: VITE_PUBLIC_WEBSITE_ORIGIN (recommended for staging/prod if hostnames don't follow rules below).
 * - `admin.example.com` → `example.com` (strip `admin.` subdomain).
 * - `admin-saddlefit.example.com` → `saddle-fit.example.com` (demodev / hyphenated admin host).
 * - Localhost → http://localhost:3001 (consumer dev server default).
 */
export function getConsumerWebsiteOrigin() {
  const fromEnv = import.meta.env.VITE_PUBLIC_WEBSITE_ORIGIN?.trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;

  if (typeof window === "undefined") return "";

  const origin = window.location.origin;

  try {
    const u = new URL(origin);
    const host = u.hostname;

    const isLoopback =
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "[::1]";
    if (isLoopback) return "http://localhost:3001";

    if (host.startsWith("admin-saddlefit.")) {
      const rest = host.slice("admin-saddlefit.".length);
      return `${u.protocol}//saddle-fit.${rest}`;
    }

    if (origin.includes("//admin.")) {
      return origin.replace("//admin.", "//");
    }
  } catch {
    return origin;
  }

  return origin;
}
